import { status } from "skin/event/status";
import api from "skin/http";
import taskConfig from "config_task";
import { setEveryFlag, toggleFlag } from "./flags";
import { loadTree } from "./loading";
import { cacheRows, clearCache, pullAllChanges, syncFlags } from "./cache";

const tableRowFx = (data, obj, rows) => {
	const row = rows.find(({ key }) => key === obj.key);
	toggleFlag(data, rows, row);
	return status.ignore;
};

const categoryIdChangeFx = (data, ms, obj, rows) => {
	cacheRows(rows);
	return api({
		method: "get",
		url: `${taskConfig.url}api/other/product-tree?id=${obj.value}`,
	})
		.then(({ data: { result: tree } }) => loadTree(data, ms, tree))
		.then(() => syncFlags(data))
		.then(() => status.action);
};

const exitFx = () => {
	clearCache();
	return status.action;
};

const nextFx = (rows) => {
	pullAllChanges(rows);
	return status.action;
};

const bulkSelectFx = (data, obj) => {
	setEveryFlag(data, obj.code === "all");
	return status.action;
};

export default function msProductExceptions(obj, ms, story, data, d, action) {
	const rows = data.curData.values.table.productExclusion?.list || [];

	if (obj.action === "row" && obj.type === "table")
		return tableRowFx(data, obj, rows);
	if (obj.action === "setInput" && obj.name === "categoryId")
		return categoryIdChangeFx(data, ms, obj, rows);
	if (obj.action === "exit") return exitFx();
	if (obj.action === "next") return nextFx(rows);
	if (obj.code === "all" || obj.code === "clear")
		return bulkSelectFx(data, obj);
	return status.action;
}
